import React from 'react';
import { Avatar } from '../common/Avatar';
import { SectionLink } from './SectionLink';
import { teamLabel } from '../../utils/teams';
import type { FloorFlagKind } from '../../types/voip';
import type { FloorRow } from '../../utils/floor';
const flagTone: Record<FloorFlagKind, string> = {
  warm: 'bg-warning/10 text-warning',
  wrap: 'bg-gold-soft text-gold',
  answer: 'bg-danger/10 text-danger',
  partial: 'bg-silver-soft text-silver'
};
interface NeedsAttentionProps {
  rows: FloorRow[];
  subtitle: string;
  onSelect: (id: string) => void;
  onViewAll: () => void;
  limit?: number;
}
export function NeedsAttention({
  rows,
  subtitle,
  onSelect,
  onViewAll,
  limit = 5
}: NeedsAttentionProps) {
  const shown = rows.slice(0, limit);
  return <section aria-labelledby="attention-heading" className="flex h-full flex-col rounded-2xl border border-line bg-surface p-6 shadow-card" data-id="element-293" data-mp="273i2454mvejv">
      <div className="mb-3 flex items-start justify-between gap-3" data-id="element-294" data-mp="cr1ryt8pvg9q">
        <div data-id="element-295" data-mp="ctee7iliccsl">
          <h2 id="attention-heading" className="text-base font-semibold text-ink" data-id="element-296" data-mp="381gpkwazq6m7">
            Needs attention
          </h2>
          <p className="mt-0.5 text-sm text-muted" data-id="element-297" data-mp="339yxyyuuxidw">{subtitle}</p>
        </div>
        <SectionLink label="View users" onClick={onViewAll} data-id="element-298" data-mp="2ybfauv4j20jy" />
      </div>
      {shown.length === 0 ? <p className="py-8 text-center text-sm text-muted" data-id="element-299" data-mp="2uavcxpc4qswr">Nothing flagged. Everyone's on track.</p> : <ul className="-mx-2 divide-y divide-line" data-id="element-300" data-mp="3qzjivnakmppt">
          {shown.map(({
        agent,
        flags
      }) => <li key={agent.id} data-id="element-301" data-mp="3m2kqpaagwsu9">
              <button type="button" onClick={() => onSelect(agent.id)} aria-label={`${agent.name}: ${flags.map(f => f.label).join(', ')}. View details`} className="flex w-full items-start gap-3 rounded-lg px-2 py-3 text-left transition-colors duration-150 ease-out hover:bg-canvas focus:outline-none focus-visible:bg-canvas" data-id="element-302" data-mp="3m2awtbmay1ja">
                <Avatar name={agent.name} size="sm" data-id="element-303" data-mp="21nr6rh1aw8je" />
                <div className="min-w-0 flex-1" data-id="element-304" data-mp="232jzy7s6fajq">
                  <p className="truncate text-sm font-semibold text-ink" data-id="element-305" data-mp="2310meoxwndln">{agent.name}</p>
                  <p className="truncate text-xs text-muted" data-id="element-306" data-mp="27zu1glsubcnx">
                    {teamLabel(agent.team)} · {flags[0].detail}
                  </p>
                </div>
                <div className="flex shrink-0 flex-col items-end gap-1" data-id="element-307" data-mp="1y2fl0m6x2nvm">
                  {flags.slice(0, 2).map(f => <span key={f.kind} className={`whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-semibold ${flagTone[f.kind]}`} data-id="element-308" data-mp="1kb120fd0emok">
                      {f.label}
                    </span>)}
                </div>
              </button>
            </li>)}
        </ul>}
      {rows.length > shown.length && <p className="mt-auto pt-3 text-xs text-subtle" data-id="element-309" data-mp="11cy6ritvbtib">+{rows.length - shown.length} more flagged</p>}
    </section>;
}